module.exports = __webpack_public_path__ + "static/media/Waving Hand 4.cc800cc4.gif";